import React, { useState } from 'react';
import * as Bixby from '$/core';
import Upload from '../Upload';
import Verify from '../Verify';

const MnpiDataSite: React.FC = () => {
  const [stage, setStage] = useState(Bixby.Enums.ClientDataSiteStage.Upload as Bixby.Enums.ClientDataSiteStage);
  const [verificationResults, setVerificationResults] = useState(
    [] as Bixby.Models.ClientDataSiteVerificationSummary[]
  );

  const setCurrentStage: (stage: Bixby.Enums.ClientDataSiteStage) => void = (
    stage: Bixby.Enums.ClientDataSiteStage
  ) => {
    setStage(stage);
  };

  const setCurrentVerificationResults: (results: Bixby.Models.ClientDataSiteVerificationSummary[]) => void = (
    results: Bixby.Models.ClientDataSiteVerificationSummary[]
  ) => {
    setVerificationResults(results);
  };

  return (
    <React.Fragment>
      {stage == Bixby.Enums.ClientDataSiteStage.Upload ? (
        <Upload
          setCurrentStage={setCurrentStage}
          setCurrentVerificationResults={setCurrentVerificationResults}
          isMnpiUpload={true}
        />
      ) : stage == Bixby.Enums.ClientDataSiteStage.Verification ? (
        <Verify setCurrentStage={setCurrentStage} verificationResults={verificationResults} isMnpiUpload={true} />
      ) : null}
    </React.Fragment>
  );
};

export default MnpiDataSite;
